import React from 'react';

import { Header, Navbar, NavPills } from '@C';
import ErrorBoundary from '@C/Error';
import { RouteSetup } from '@C/Settings';

const routes = [
  {
    name: 'Reminder',
    path: '/account/app-settings/reminder-notifications',
    display: false,
  },
  {
    name: 'Reset Account',
    path: '/account/app-settings/reset-account',
    display: false,
  },
  {
    name: 'Profit Margin',
    path: '/account/app-settings/profit-margin',
  },
];

const Settings = () => {
  return (
    <main>
      <div className="page-wrapper">
        <Header title="Bunk Setup" />
        <Navbar />
        <div className="page-content">
          <section className="page-components">
            <div className="page-title">
              <h1> App Settings</h1>
            </div>
            <ErrorBoundary>
              <NavPills routes={routes} />
              <RouteSetup />
            </ErrorBoundary>
          </section>
        </div>
      </div>
    </main>
  );
};

export { Settings };
